// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Yo-z","breadcrumbForward":"Zo-z","breadcrumbBack":"_o-z","selected":"ap-z"};